/* src/app/private/components/analytics/multi-line-chart/multi-line-chart.component.scss */
.chart,
h4 {
  color: rgb(43, 208, 41);
  font-size: 15px;
  margin-top: 10px;
}
.chart h2 {
  font-size: 20px;
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 0;
  color: var(--bg);
}
.chart h4 {
  margin-left: 20px;
  margin-bottom: 2px;
  color: var(--dark-grey);
}
.graph_ {
  margin: 10px;
  width: 50%;
}
.section {
  background: #fff;
}
.chart {
  padding: 5px;
  display: flex;
  flex-direction: row;
}
.circle_graph_right {
  display: flex;
  flex-direction: row;
  justify-content: CENTER;
  align-items: CENTER;
}
.h-social-img {
  display: flex;
  flex-direction: column;
  align-items: CENTER;
}
.h-social-img img {
  width: 24px;
}
.section {
  padding: 15px;
  border-radius: 10px;
}
.liner-value {
  color: #606060;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
}
.col-md-4 {
  margin-top: 24px;
}
.line-bar-heading {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 7px;
}
.line-bar-heading .line-bar-img {
  height: 23px;
  width: 23px;
  object-fit: contain;
}
.line-bar-heading .line-bar-text {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #888888;
}
.title {
  font-family: Inter;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #0D4259;
  margin-top: -18px;
}
.sub-title {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #767373;
  margin-top: 4px;
  margin-bottom: 14px;
}
.line_bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.chart-container {
  position: relative;
  width: 100%;
  height: 200px;
}
@media (min-width: 768px) {
  .chart-container {
    height: 350px;
  }
}
/*# sourceMappingURL=multi-line-chart.component.css.map */
